import { useEffect, useState } from 'react'
import { getActivityPublicCapacity } from '../libs/CloudFunctionsApiHandler'
import { useMounted } from './useMounted'

export const useActivityPublicCapacity = (activityId?: string) => {
  const isMounted = useMounted()
  const [isAtOrOverCapacity, setIsAtOrOverCapacity] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (!activityId) return

    let cancelled = false
    setIsLoading(true)

    getActivityPublicCapacity({ activityId })
      .then((result) => {
        if (cancelled || !isMounted()) return
        setIsAtOrOverCapacity(result.isAtOrOverCapacity)
      })
      .catch((error) => {
        console.error('[useActivityPublicCapacity] error', error)
      })
      .finally(() => {
        if (cancelled || !isMounted()) return
        setIsLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [activityId, isMounted])

  return { isAtOrOverCapacity, isLoading }
}
